import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { Skeleton } from "primereact/skeleton";
import { TreeTable } from "primereact/treetable";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CardSeplag from "../../../components/CardSeplag";
//import { buscarPerfil } from "../../../config/global";
import { useLocation } from "react-router-dom";
import ModalLancamentosMonitora from "./modalLancamentos";

import {
  carregarArvoreMonitoraComFiltro,
  carregarArvoreResumidaMonitora,
  getArvoreIdenPtaFiplan,
  listarExercicios,
} from "../../../service/ArvoreMonitora";

import "./style.modules.scss";

const MonitoraLancamentos = () => {
  const user = useSelector((state) => state.userReducer.user);
  const location = useLocation();

  const filtroReducer = useSelector((state) => state.filtroReducer);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [ptaMonitoraSelecionado, setPtaMonitoraSelecionado] = useState();
  const [atualizaList, setAtualizaList] = useState(false);
  const [cDadosArvore, setCDadosArvore] = useState([]);
  const [cDadosExercicios, setCDadosExercicios] = useState([]);
  const [cDadosCiclo, setCDadosCiclo] = useState([]);
  const [cDadosOrgaos, setCDadosOrgaos] = useState([]);
  const [cDadosUOs, setCDadosUOs] = useState([]);
  const [cDadosProgramas, setCDadosProgramas] = useState([]);
  const [cDadosProdutos, setCDadosProdutos] = useState([]);

  const [programaSelecionado, setProgramaSelecionado] = useState([]);
  const [uoSelecionada, setUoSelecionada] = useState([]);
  const [orgaoSelecionado, setOrgaoSelecionado] = useState([]);
  const [exercicioSelecionado, setExercicioSelecionado] = useState();
  const [, setIsPodeEditar] = useState([]);
  const [isMONRL_ADMIN_CENTRAL] = useState(buscarPerfil("MONRL_ADMIN_CENTRAL"));

  const nomePagina = "Lancamentos Monitora";

  function buscarPerfil(pNomeRole) {
    let retorno = false;
    if (user) {
      user.contaAcesso.authorities.forEach((perfilUser) => {
        if (perfilUser.nomeRole === pNomeRole) {
          retorno = true;
        }
      });
    } else {
      retorno = false;
    }

    return retorno;
  }

  useEffect(() => {
    if (atualizaList === true) {
      setAtualizaList(false);
    }
    let carregaFiltros = filtroReducer.filtros.filter((filtro) => filtro.namePagina === nomePagina);

    if (carregaFiltros.length === 0) {
      carregarArvoreResumidaMonitora().then((res) => {
        montarArvore(res);
        setExercicioSelecionado(res.listaExercicios[0]);
        setOrgaoSelecionado(res.orgaoFiplans[0]);
        setUoSelecionada(res.unidadeOrcamentarias[0]);
        setProgramaSelecionado(res.programas[0]);
      });
    } else {
      getFiltroPagina().then();
    }

    async function getFiltroPagina() {
      let filtros = filtroReducer.filtros;
      let filtro = filtros.filter((filtro) => filtro.namePagina === nomePagina);

      if (filtro) {
        await listarExercicios().then((resExercicios) => {
          setCDadosExercicios(resExercicios.data);
        });

        let ExercicioSelecionado = filtro[0].campos.find((element) => element.key === "Exercicio");
        await buscarExercicio(ExercicioSelecionado.value).then((res) => {
          setExercicioSelecionado(ExercicioSelecionado ? ExercicioSelecionado.value : null);
        });

        let OrgaoSelecionado = filtro[0].campos.find((element) => element.key === "Orgao");
        await buscarOrgao(ExercicioSelecionado.value, OrgaoSelecionado.value).then((res) => {
          setOrgaoSelecionado(OrgaoSelecionado ? OrgaoSelecionado.value : null);
        });

        let UOSelecionado = filtro[0].campos.find((element) => element.key === "UO");
        await buscarUO(ExercicioSelecionado.value, OrgaoSelecionado.value, UOSelecionado.value).then((res) => {
          setUoSelecionada(UOSelecionado ? UOSelecionado.value : null);
        });

        let ProgramaSelecionado = filtro[0].campos.find((element) => element.key === "Programa");
        await buscarPrograma(
          ExercicioSelecionado.value,
          OrgaoSelecionado.value,
          UOSelecionado.value,
          ProgramaSelecionado.value
        ).then((res) => {
          setProgramaSelecionado(ProgramaSelecionado ? ProgramaSelecionado.value : null);
        });

        return true;
      }

      return false;
    }

    async function buscarExercicio(exercicio) {
      setExercicioSelecionado(exercicio);

      let filtro = {
        idenExercicio: exercicio.idenExercicio,
        idenOrgao: null,
        idenUo: null,
        idenPrograma: null,
        idenProduto: null,
      };
      let eager = true;
      await carregarArvoreMonitoraComFiltro(filtro, defaultArvoreMonitora, eager).then((res) => {
        setCDadosCiclo(res.parametroExercicio);
        setCDadosOrgaos(res.orgaoFiplans);
        setCDadosProdutos(res.produto);
      });
    }

    async function buscarOrgao(exercicio, orgao) {
      setExercicioSelecionado(exercicio);
      setOrgaoSelecionado(orgao);
      setCDadosUOs(null);
      setCDadosProgramas(null);
      setCDadosProdutos(null);
      setCDadosArvore(null);
      let filtro = {
        idenExercicio: exercicio.idenExercicio,
        idenOrgao: orgao.idenOrgao,
        idenUo: null,
        idenPrograma: null,
        idenProduto: null,
      };
      let eager = true;
      await carregarArvoreMonitoraComFiltro(filtro, defaultArvoreMonitora, eager).then((res) => {
        setCDadosUOs(res.unidadeOrcamentarias);
        setCDadosProdutos(res.produto);
      });
    }

    async function buscarUO(exercicio, orgao, uo) {
      let filtro = {
        idenExercicio: exercicio.idenExercicio,
        idenOrgao: orgao.idenOrgao,
        idenUo: uo.idenUo,
        idenPrograma: null,
        idenProduto: null,
      };
      let eager = true;
      await carregarArvoreMonitoraComFiltro(filtro, defaultArvoreMonitora, eager).then((res) => {
        setCDadosProgramas(res.programas);
        setCDadosProdutos(res.produto);
      });
    }

    async function buscarPrograma(exercicio, orgao, uo, programa) {
      let filtro = {
        idenExercicio: exercicio.idenExercicio,
        idenOrgao: orgao.idenOrgao,
        idenUo: uo.idenUo,
        idenPrograma: programa.idenPrograma,
        // idenProduto: produto.idenProduto,
      };
      let eager = true;
      await carregarArvoreMonitoraComFiltro(filtro, defaultArvoreMonitora, eager).then((res) => {
        if (res.arvorePtaMonitoras != null) {
          setCDadosArvore(res.arvorePtaMonitoras);
        } else {
          setCDadosArvore(null);
        }
      });
    }
  }, [atualizaList]);

  function montarArvore(dadosArvore) {
    if (dadosArvore != null && dadosArvore.arvorePtaMonitoras != null) {
      setCDadosArvore(dadosArvore.arvorePtaMonitoras);
    } else {
      setCDadosArvore({ content: { key: null, statusItem: null, tipoItemPta: null } });
    }
    setCDadosExercicios(dadosArvore != null ? dadosArvore.listaExercicios : null);
    setCDadosCiclo(
      dadosArvore && dadosArvore.parametroExercicio
        ? dadosArvore.parametroExercicio
        : { cicloMonitoramento: { statusCiclo: "" } }
    );
    setCDadosOrgaos(dadosArvore != null ? dadosArvore.orgaoFiplans : null);
    setCDadosUOs(dadosArvore != null ? dadosArvore.unidadeOrcamentarias : null);
    setCDadosProgramas(dadosArvore != null ? dadosArvore.programas : null);
    setCDadosProdutos(dadosArvore != null ? dadosArvore.produto : null);
  }

  const defaultArvoreMonitora = {
    arvorePtaMonitoras: cDadosArvore,
    listaExercicios: cDadosExercicios,
    parametroExercicio: cDadosCiclo,
    orgaoFiplans: cDadosOrgaos,
    unidadeOrcamentarias: cDadosUOs,
    programas: cDadosProgramas,
    produto: cDadosProdutos,
  };

  const onChangeExercicio = async (e) => {
    if (e.value != null) {
      let exercicio = e.value ? e.value : e;
      setExercicioSelecionado(exercicio);
      setOrgaoSelecionado(null);
      setUoSelecionada(null);
      setProgramaSelecionado(null);
      setCDadosOrgaos(null);
      setCDadosUOs(null);
      setCDadosProgramas(null);
      setCDadosProdutos(null);
      setCDadosArvore(montarArvore(null));
      let filtro = {
        idenExercicio: exercicio.idenExercicio,
        idenOrgao: null,
        idenUo: null,
        idenPrograma: null,
        idenProduto: null,
      };
      let eager = true;
      await carregarArvoreMonitoraComFiltro(filtro, defaultArvoreMonitora, eager).then((res) => {
        montarArvore(res);
      });
    } else {
      setExercicioSelecionado(null);
      setOrgaoSelecionado(null);
      setUoSelecionada(null);
      setProgramaSelecionado(null);
    }
  };

  const onChangeOrgao = async (e) => {
    let orgao = e.value ? e.value : e;
    setOrgaoSelecionado(orgao);
    setUoSelecionada(null);
    setProgramaSelecionado(null);
    setCDadosUOs(null);
    setCDadosProgramas(null);
    setCDadosProdutos(null);
    setCDadosArvore(null);
    let filtro = {
      idenExercicio: exercicioSelecionado.idenExercicio,
      idenOrgao: orgao.idenOrgao,
      idenUo: null,
      idenPrograma: null,
      idenProduto: null,
    };
    let eager = true;

    await carregarArvoreMonitoraComFiltro(filtro, defaultArvoreMonitora, eager).then((res) => {
      setCDadosCiclo(res.parametroExercicio);
      setCDadosOrgaos(res.orgaoFiplans);
      setCDadosUOs(res.unidadeOrcamentarias);
    });
  };

  const onChangeUo = async (e) => {
    let uo = e.value ? e.value : e;
    setUoSelecionada(uo);
    setProgramaSelecionado(null);
    setCDadosProdutos(null);
    setCDadosArvore(null);
    let filtro = {
      idenExercicio: exercicioSelecionado.idenExercicio,
      idenOrgao: orgaoSelecionado.idenOrgao,
      idenUo: uo.idenUo,
      idenPrograma: null,
      idenProduto: null,
    };
    let eager = true;
    await carregarArvoreMonitoraComFiltro(filtro, defaultArvoreMonitora, eager).then((res) => {
      setCDadosCiclo(res.parametroExercicio);
      setCDadosOrgaos(res.orgaoFiplans);
      setCDadosUOs(res.unidadeOrcamentarias);
      setCDadosProgramas(res.programas);
      setCDadosProdutos(res.produto);
    });
  };

  const onChangePrograma = async (e) => {
    let programa = e.value ? e.value : e;
    setProgramaSelecionado(programa);
    let filtro = {
      idenExercicio: exercicioSelecionado.idenExercicio,
      idenOrgao: orgaoSelecionado.idenOrgao,
      idenUo: uoSelecionada.idenUo,
      idenPrograma: programa.idenPrograma,
    };

    let filtroPagina = {
      filtros: [
        {
          namePagina: nomePagina,
          campos: [
            { key: "Exercicio", value: exercicioSelecionado },
            { key: "Orgao", value: orgaoSelecionado },
            { key: "UO", value: uoSelecionada },
            { key: "Programa", value: programa },
          ],
        },
      ],
    };

    dispatch({ type: "setFiltros", value: filtroPagina });
    let eager = true;
    await carregarArvoreMonitoraComFiltro(filtro, defaultArvoreMonitora, eager).then((res) => {
      setCDadosCiclo(res.parametroExercicio);
      setCDadosOrgaos(res.orgaoFiplans);
      setCDadosUOs(res.unidadeOrcamentarias);
      setCDadosProgramas(res.programas);
      setCDadosProdutos(res.produto);
      if (res.arvorePtaMonitoras != null) {
        setCDadosArvore(res.arvorePtaMonitoras);
      } else {
        setCDadosArvore(null);
      }
    });
  };
  function handleShowModalLancamentos(rowData, habilitaEdicao) {
    setPtaMonitoraSelecionado(rowData);
    setIsPodeEditar(habilitaEdicao);
    setVisible(true);
  }

  const onSalvar = () => {
    /*pesquisarLista().then((res) => {
      setListaEmpresa(res.content);
    });*/
  };

  const acoesTemplate = (node, column) => {
    if (node.data.statusItem !== "CANCELADA") {
      node.data.flagTipoPermissao = isMONRL_ADMIN_CENTRAL ? "E" : node.data.flagTipoPermissao;
      let habilitaEdicao = node.data.flagTipoPermissao === "E" ? true : false;
      habilitaEdicao =
        habilitaEdicao &&
        cDadosCiclo &&
        cDadosCiclo.cicloMonitoramento &&
        cDadosCiclo.cicloMonitoramento.statusCiclo !== "FECHADO"
          ? true
          : false;

      return (
        <>
          {!habilitaEdicao && (
            <Button
              type="button"
              icon="pi pi-search"
              className="p-button-success Raised"
              onClick={() => handleShowModalLancamentos(node, habilitaEdicao)}
            ></Button>
          )}
          {habilitaEdicao && (
            <Button
              type="button"
              icon="pi pi-pencil"
              className="p-button-warning Raised"
              onClick={() => handleShowModalLancamentos(node, habilitaEdicao)}
            ></Button>
          )}
        </>
      );
    }
  };

  const columnStatusTemplate = (node, column) => {
    return (
      <div className="customer-badge" style={{ overflow: "visible" }}>
        <p
          style={{
            color: node.data.corStatus,
            whiteSpace: "normal",
          }}
        >
          {node.data.statusItem}
        </p>
      </div>
    );
  };

  const itemArvoreTemplate = (node, column) => {
    return (
      <span>
        {node.data.tipoItemPta.descTipoItemPta + ": " + node.codigoFiplanItem + " - " + node.data.descricaoItem}
      </span>
    );
  };

  const TableLoader = (props) => {
    const products = Array.from({ length: 15 });
    const skeletonTemplate = () => {
      return <Skeleton></Skeleton>;
    };

    return (
      <CardSeplag title={"MONITORAMENTO : LANÇAMENTO DE DADOS "}>
        <div className="p-fluid grid line-height-4">
          <div className="field col-12 md:col-9 ">
            <div className="p-fluid grid line-height-4">
              <div className="field col-12 md:col-4 ">
                <span>
                  <label htmlFor="selExercicio">Exercício</label>
                  <Dropdown placeholder="Selecione um exercício" />
                </span>
              </div>
              <div className="field col-12 md:col-4">
                <span>
                  <label htmlFor="selOrgao">Órgão</label>
                  <Dropdown placeholder="Selecione um Órgão" />
                </span>
              </div>
              <div className="field col-12 md:col-4">
                <span>
                  <label htmlFor="selUO">U.O</label>
                  <Dropdown placeholder="Selecione uma U.O." />
                </span>
              </div>
            </div>
            <div className="p-fluid grid line-height-4">
              <div className="field col-12">
                <span>
                  <label htmlFor="selPrograma">Programa</label>
                  <Dropdown placeholder="Selecione um Programa" />
                </span>
              </div>
            </div>
          </div>
          <div className="field col-12 md:col-3 flex flex-wrap align-items-center justify-content-center card-container">
            <span className="vertical-align-text-bottom">
              <Button type="button" style={{ width: "17rem" }} className={"p-button-secondary Raised"}>
                <p style={{ width: "100%" }}>{"CICLO"}</p>
              </Button>
            </span>
          </div>
        </div>
        <DataTable value={products} responsiveLayout="scroll" className="p-datatable-striped">
          <Column header="Ações" body={skeletonTemplate} style={{ display: "flex", justifyContent: "center" }}></Column>
          <Column header="Descrição" body={skeletonTemplate} style={{ width: "68%" }}></Column>
          <Column header="Status" body={skeletonTemplate} style={{ textAlign: "justify", width: "20%" }}></Column>
        </DataTable>
      </CardSeplag>
    );
  };

  const modifyCdadosArvore = (cDadosArvore) => {
    if (cDadosArvore.content && cDadosArvore.content?.key !== null) {
      const cDadosArvoreAcaoFiltered = cDadosArvore.content.filter((acao) => {
        if (acao.data.statusItem !== "CANCELADA") {
          return acao;
        }
      });

      const cDadosArvoreProdutoFiltered = cDadosArvoreAcaoFiltered.filter((acao) => {
        let produtoResult;
        produtoResult = acao.children?.filter((produto) => {
          if (produto.data.statusItem !== "CANCELADA") {
            return produto;
          }
        });
        if (produtoResult === undefined) return (produtoResult = [(acao.children = [])]);
        if (produtoResult.length <= 0) {
          acao.children = [];
        }
        return produtoResult;
      });

      const cDadosArvoreSubAcaoFiltered = cDadosArvoreProdutoFiltered.filter((acao) => {
        return acao.children.filter((produto) => {
          const subAcaoFiltered = [];
          const children = produto?.children?.filter((subAcao) => {
            if (subAcao.data.statusItem !== "CANCELADA") {
              subAcaoFiltered.push(subAcao);
              return subAcao;
            }
          });
          produto.children = subAcaoFiltered;
          return children;
        });
      });
      const cDadosArvoreEtapaFiltered = cDadosArvoreSubAcaoFiltered.filter((acao) => {
        return acao.children?.filter((produto) => {
          return produto?.children.filter((subAcao) => {
            const etapaFiltered = [];

            const etapa = subAcao?.children?.filter((etapa) => {
              if (etapa.data.statusItem !== "CANCELADA") {
                etapaFiltered.push(etapa);
                return etapa;
              }
            });

            subAcao.children = etapaFiltered;
            return etapa;
          });
        });
      });

      return cDadosArvoreEtapaFiltered;
    } else {
      cDadosArvore = [];
    }
  };

  const onExpand = async (event) => {
    if (event.node.children.length <= 0) {
      await getArvoreIdenPtaFiplan(event.node.idenPtaMonitora).then((response) => {
        setLoading(true);

        setTimeout(() => {
          setLoading(true);

          if (event.node.data.descricaoNivelItem === "SUBAÇÃO") {
            const content = cDadosArvore.content.map((arvore) => {
              arvore.children.map((produto) => {
                if (produto.idenPtaFiplan === event.node.idenPtaFiplanPai && produto.exercicio.ano <= 2023) {
                  produto.children.map((subAcao) => {
                    if (subAcao.idenPtaMonitora === event.node.idenPtaMonitora) {
                      const etapa = response.data.map((etapa) => {
                        return { ...etapa, leaf: true };
                      });

                      subAcao.children = etapa;
                    }
                    return subAcao;
                  });
                }
              });

              return arvore;
            });

            setCDadosArvore((prevState) => ({ ...prevState, content }));
          }

          if (event.node.data.descricaoNivelItem === "PRODUTO") {
            const content = cDadosArvore.content.map((arvore) => {
              if (arvore.idenPtaFiplan === event.node.idenPtaFiplanPai) {
                arvore.children.map((produto) => {
                  if (produto.idenPtaMonitora === event.node.idenPtaMonitora) {
                    const children = response.data.map((subAcao) => {
                      if (produto.exercicio.ano >= 2024) {
                        return { ...subAcao, leaf: true };
                      }
                      return subAcao;
                    });

                    produto.children = children;
                  }
                  return produto;
                });
              }
              return arvore;
            });

            setCDadosArvore((prevState) => ({ ...prevState, content }));
          }

          if (event.node.data.descricaoNivelItem === "AÇÃO") {
            const content = cDadosArvore.content.map((arvore) => {
              if (arvore.idenPtaMonitora === event.node.idenPtaMonitora) {
                arvore.children = response.data;
              }
              return arvore;
            });
            setCDadosArvore((prevState) => ({ ...prevState, content }));
          }

          setLoading(false);
        }, 250);
      });
    }
  };
  // useEffect(() => {}, [cDadosArvore]);

  return (
    <CardSeplag title={"MONITORAMENTO : LANÇAMENTO DE DADOS "}>
      <div className="p-fluid grid line-height-4">
        <div className="field col-12 md:col-9 ">
          <div className="p-fluid grid line-height-4">
            <div className="field col-12 md:col-4 ">
              <span>
                <label htmlFor="selExercicio">Exercício</label>
                <Dropdown
                  emptyMessage="Dados não encontrados"
                  emptyFilterMessage="Opção não encontrada"
                  id="selExercicio"
                  value={exercicioSelecionado}
                  options={cDadosExercicios}
                  onChange={onChangeExercicio}
                  optionLabel="ano"
                  filter
                  showClear
                  filterBy="ano"
                  placeholder="Selecione um exercício"
                />
              </span>
            </div>
            <div className="field col-12 md:col-4">
              <span>
                <label htmlFor="selOrgao">Órgão</label>
                <Dropdown
                  emptyMessage="Dados não encontrados"
                  emptyFilterMessage="Opção não encontrada"
                  id="selOrgao"
                  value={orgaoSelecionado}
                  options={cDadosOrgaos}
                  onChange={onChangeOrgao}
                  optionLabel="descricaoFiplan"
                  filter
                  showClear
                  filterBy="descricaoFiplan"
                  placeholder="Selecione um Órgão"
                />
              </span>
            </div>
            <div className="field col-12 md:col-4">
              <span>
                <label htmlFor="selUO">U.O</label>
                <Dropdown
                  emptyMessage="Dados não encontrados"
                  emptyFilterMessage="Opção não encontrada"
                  id="selUO"
                  value={uoSelecionada}
                  options={cDadosUOs}
                  onChange={onChangeUo}
                  optionLabel="descricaoFiplan"
                  filter
                  showClear
                  filterBy="descricaoFiplan"
                  placeholder="Selecione uma U.O."
                />
              </span>
            </div>
          </div>
          <div className="p-fluid grid line-height-4">
            <div className="field col-12">
              <span>
                <label htmlFor="selPrograma">Programa</label>
                <Dropdown
                  emptyMessage="Dados não encontrados"
                  emptyFilterMessage="Opção não encontrada"
                  id="selPrograma"
                  value={programaSelecionado}
                  options={cDadosProgramas}
                  onChange={onChangePrograma}
                  optionLabel="descricaoFiplan"
                  showClear
                  filter
                  filterBy="descricaoFiplan"
                  placeholder="Selecione um Programa"
                  className="selProgramaIcon"
                />
              </span>
            </div>
          </div>
        </div>
        <div className="field col-12 md:col-3 flex flex-wrap align-items-center justify-content-center card-container">
          <span className="vertical-align-text-bottom">
            <Button
              type="button"
              style={{ width: "17rem" }}
              className={
                cDadosCiclo && cDadosCiclo.cicloMonitoramento && cDadosCiclo.cicloMonitoramento.statusCiclo === "ABERTO"
                  ? "p-button-success Raised"
                  : cDadosCiclo &&
                    cDadosCiclo.cicloMonitoramento &&
                    cDadosCiclo.cicloMonitoramento.statusCiclo === "PENDENTE"
                  ? "p-button-help Raised"
                  : cDadosCiclo &&
                    cDadosCiclo.cicloMonitoramento &&
                    cDadosCiclo.cicloMonitoramento.statusCiclo === "ESTRATEGICO"
                  ? "p-button-info Raised"
                  : cDadosCiclo &&
                    cDadosCiclo.cicloMonitoramento &&
                    cDadosCiclo.cicloMonitoramento.statusCiclo === "CONSOLIDACAO"
                  ? "p-button-warning Raised"
                  : "p-button-danger Raised"
              }
            >
              <p style={{ width: "100%" }}>
                {cDadosCiclo && cDadosCiclo.cicloMonitoramento
                  ? "CICLO " + cDadosCiclo.cicloMonitoramento.statusCiclo
                  : "CICLO FECHADO"}
              </p>
            </Button>
          </span>
        </div>
      </div>
      <div>
        <TreeTable
          emptyMessage="Dados não encontrados"
          value={cDadosArvore && modifyCdadosArvore(cDadosArvore)}
          lazy
          // selectionMode="single"
          // onSelect={onSelect}
          // onUnselect={onUnselect}
          onExpand={onExpand}
          loading={loading}
          key="idenArvorePtaMonitoraView"
        >
          <Column body={acoesTemplate} header="Ações" style={{ textAlign: "center", width: "12%" }} />
          <Column
            field="descricaoItem"
            body={itemArvoreTemplate}
            style={{ textAlign: "justify", width: "58%" }}
            expander
            header="Descrição"
          />
          <Column
            field="statusItem"
            body={columnStatusTemplate}
            style={{ textAlign: "center", width: "20%" }}
            header="Status"
          />
        </TreeTable>
      </div>

      {visible && (
        <ModalLancamentosMonitora
          visible={visible}
          setVisible={setVisible}
          onSalvar={onSalvar}
          ptaMonitora={ptaMonitoraSelecionado}
          setAtualizaList={setAtualizaList}
          isPodeEditar={true}
          setIsPodeEditar={setIsPodeEditar}
          isMONRL_ADMIN_CENTRAL={isMONRL_ADMIN_CENTRAL}
        />
      )}
    </CardSeplag>
  );
};

export default MonitoraLancamentos;
